export default __webpack_public_path__ + "static/media/HalfMoon1.44c4bf9b.jpg";